import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicineService } from 'src/core/services/medicine.service';
import { EditMedicineDosagePackageTypePayload, MedicineDosagePackageType, PackageType } from 'src/interfaces/medicine';

export interface DialogData {
  title: string;
  message: string;
  medicineId: number;
  medicineDosageTypeId: number;
  packageTypes: PackageType[];
  medicineDosagePackageType: MedicineDosagePackageType;
}
@Component({
  selector: 'core-medicine-dosage-package-type-edit-dialog',
  templateUrl: './medicine-dosage-package-type-edit-dialog.component.html',
  styleUrls: ['./medicine-dosage-package-type-edit-dialog.component.scss']
})
export class MedicineDosagePackageTypeEditDialogComponent implements OnInit {

  packageTypes: PackageType[] = [];
  medicineDosagePackageType: MedicineDosagePackageType | null = null;

  medicineDosagePackageTypeForm = this._formBuilder.group({
    packageType: ['', Validators.required],
    containedQuantity: ['', Validators.compose([Validators.required, Validators.min(1)])],
    labelName: ['', Validators.compose([Validators.required, Validators.maxLength(25)])],
    price: ['', Validators.compose([Validators.required, Validators.min(1)])]
  })

  labelNameExceeds25Chars: boolean = false;

  constructor(
    public _dialogRef: MatDialogRef<MedicineDosagePackageTypeEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: FormBuilder,
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {

    this.packageTypes = this.data.packageTypes;
    this.medicineDosagePackageType = this.data.medicineDosagePackageType;

    const selectedPackageType: PackageType | undefined = this.packageTypes
      .find(type => {
        if (!this.medicineDosagePackageType) return false;
        return this.medicineDosagePackageType.package_type_id === type.id;
      })

    // update form value 
    this.medicineDosagePackageTypeForm.patchValue({
      packageType: selectedPackageType ? selectedPackageType : null,
      containedQuantity: this.medicineDosagePackageType.contained_quantity,
      labelName: this.medicineDosagePackageType.label_name,
      price: this.medicineDosagePackageType.price
    })


    this.medicineDosagePackageTypeForm.controls['labelName']
      .valueChanges.subscribe((value) => {
        this.labelNameExceeds25Chars = value.length > 25;
      })
  }

  async save() {

    if (!this.medicineDosagePackageType) return;
    const payload: EditMedicineDosagePackageTypePayload = {
      contained_quantity: this.medicineDosagePackageTypeForm.value.containedQuantity,
      package_type_id: this.medicineDosagePackageTypeForm.value.packageType.id,
      label_name: this.medicineDosagePackageTypeForm.value.labelName,
      price: this.medicineDosagePackageTypeForm.value.price
    }

    const success: boolean = await this._medicineService
      .editMedicineDosagePackageType(
        this.data.medicineId,
        this.data.medicineDosageTypeId,
        this.medicineDosagePackageType.id,
        payload
      );

    if (success)
      this._dialogRef.close(success);
  }

  async createPackageType(event: Event) {
    event.stopPropagation();
    const newPackageType: PackageType = await this._medicineService
      .openPackageTypeCreateDialog(
        "New package type",
        "Create new package type"
      );

    if (newPackageType) {
      // add dosage unit to the list dosage types
      this.packageTypes.push(newPackageType);
      // clone array 
      this.packageTypes = [...this.packageTypes];
      // Update the form value to the newly created dosage type
      this.medicineDosagePackageTypeForm.patchValue({
        packageType: newPackageType
      });
    }
  }

}
